import { Controller } from "@hotwired/stimulus"

/*
  This controller is used to manage the status of the user feedback thumbs
  in the Assistant answers.

  How to use: /app/views/message_answers/_feedback_buttons.html.erb
 */
export default class extends Controller {
  static targets = ["thumb"]

  handleClick(event) {
    const element = event.currentTarget;
    const value = element.getAttribute("data-value");
    const form = element.closest("form");

    this._clearDataFeedback();

    element.setAttribute("data-feedback", value);
    
    // Disable the button after form submission starts
    if (form) {
      form.addEventListener("submit", () => {
        element.setAttribute("disabled", "disabled");
      }, { once: true });
    } else {
      // Fallback: disable after a short delay
      setTimeout(() => {
        element.setAttribute("disabled", "disabled");
      }, 100);
    }
  }

  // private

  _clearDataFeedback() {
    this.thumbTargets.forEach((element) => {
      element.removeAttribute("data-feedback");
    });
  }
}
